import React from "react";
import { useState, useEffect, memo } from "react";
import moment from "moment";
// import { UNIVERSAL_SEARCH_URL } from "../../../utils/constants";
import profilesvg from "./../../assets/profile.svg"
import userprofile from "./../../assets/user-profile.svg";
import { Button } from "../../common/Button/Button"
import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
import audioIcon from "../../assets/audioIcon.svg"
import audioIcon2 from "../../assets/audioIcon2.svg"
import videoIcon from "../../assets/videoIcon.svg"
import videoIcon2 from "../../assets/videoIcon2.svg"
import textIcon from "../../assets/textIcon.svg"
import textIcon2 from "../../assets/textIcon2.svg"
import viewIconTwo from "../../assets/viewIconTwo.svg"
import Select from "react-select";
import Spinner from '../../common/Spinner/Spinner';

import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import {
    TextField
} from '@material-ui/core';
import api from "../../utils/api";
import { toast } from "react-toastify";

function UserDetailContainerTwo(props) {
    const [selectedOption, setSelectedOption] = useState(null)
    const [isTestimonialAddModalOpen, setIsTestimonialAddModalOpen] = useState(false);
    const [isTestimonialModalOpen, setIsTestimonialModalOpen] = useState(false);
    const [iconClickedName, setIconClickedName] = useState(null);

    const [addedTestimonials, setAddedTestimonials] = useState(null);
    const [video, setVideo] = useState("");
    const [audio, setAudio] = useState("");
    const [text, setText] = useState("");
    const [isTestimonialEdit, setIsTestimonialEdit] = useState(false)

    const [editedTestimonialVal, setEditedTestimonialVal] = useState("");


    const onTestimonialChange = (option) => {
        console.log(option, ">>>testimonial change option")
        if (option) {
            setSelectedOption(option);
        } else {
            setSelectedOption(null);
        }
    }

    // modal open when there is option selected for testimonal add
    useEffect(() => {
        if (selectedOption) {
            setIsTestimonialAddModalOpen(!isTestimonialAddModalOpen);
        }
    }, [selectedOption])

    useEffect(() => {
        console.log(props.userTestimonials, ">>>>props.userTestimonials in useEffect");

        setAddedTestimonials(props.userTestimonials)
    }, [props.userTestimonials])

    const handleTestimonialIconClick = (e) => {
        setIconClickedName(e.target.name);
        setIsTestimonialModalOpen(!isTestimonialModalOpen);

        if (e.target.name == "video") {
            setEditedTestimonialVal(addedTestimonials?.Video)
        }

        if (e.target.name == "audio") {
            setEditedTestimonialVal(addedTestimonials?.Audio)
        }

        if (e.target.name == "text") {
            setEditedTestimonialVal(addedTestimonials?.Text)
        }
    }

    const handleVideoInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name, ">>>>name")
        console.log(value, ">>>>value");

        setVideo(value)
    };

    const handleAudioInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name, ">>>>name")
        console.log(value, ">>>>value");

        setAudio(value)
    };

    const handleTextInputChange = (e) => {
        const { name, value } = e.target;
        console.log(name, ">>>>name")
        console.log(value, ">>>>value");

        setText(value)
    };

    const uploadVideo = async () => {
        try {
            if (props.userDetail && video) {
                const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

                if (nUserId && sMobile && nEntryId) {
                    console.log(video, ">>>>>video");
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
                    console.log(payload, ">>>>video upload payload");

                    const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
                    console.log(res, ">>>>res on upload video");

                    if (res) {
                        toast(String("Video testimonal saved successfully"), {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });

                        setVideo(null);
                        setIsTestimonialAddModalOpen(false)
                        setSelectedOption(null);
                    }
                }
            }
        } catch (err) {
            toast(String("Video testimonial not saved"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo(null);
            setIsTestimonialAddModalOpen(false)
            setSelectedOption(null);
        }
    };

    const uploadAudio = async () => {
        try {
            if (props.userDetail && audio) {
                const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

                if (nUserId && sMobile && nEntryId) {
                    console.log(video, ">>>>>video");
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
                    console.log(payload, ">>>>audio upload payload");

                    const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
                    console.log(res, ">>>>res on upload audio");

                    if (res) {
                        toast(String("Audio testimonal saved successfully"), {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });

                        setAudio(null);
                        setIsTestimonialAddModalOpen(false);
                        setSelectedOption(null);
                    }
                }
            }
        } catch (err) {
            toast(String("Audio testimonial not saved"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setAudio(null);
            setIsTestimonialAddModalOpen(false)
            setSelectedOption(null);
        }
    };

    const uploadText = async () => {
        try {
            if (props.userDetail && text) {
                const { nUserId, sMobile, nEntryId } = props?.userDetail[0];

                if (nUserId && sMobile && nEntryId) {
                    console.log(text, ">>>>>Text");
                    const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text } };
                    console.log(payload, ">>>>text upload payload");

                    const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
                    console.log(res, ">>>>res on upload text");

                    if (res) {
                        toast(String("Text testimonal saved successfully"), {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });

                        setText(null);
                        setIsTestimonialAddModalOpen(false);
                        setSelectedOption(null);
                    }
                }
            }
        } catch (err) {
            toast(String("Text testimonial not saved"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setText(null);
            setIsTestimonialAddModalOpen(false)
            setSelectedOption(null);
        }
    };

    const handleCancelUpload = () => {
        setVideo(null);
        setAudio(null);
        setText(null)
        setSelectedOption(null);

        setIsTestimonialAddModalOpen(false);
    }

    const handleCancelUploadNew = () => {
        setVideo(null);
        setAudio(null);
        setText(null)
        setIconClickedName(null);
        setIsTestimonialModalOpen(false);
        setEditedTestimonialVal("");
        setIconClickedName(null);
        setIsTestimonialEdit(false);
    }

    const editTestimonialClicked = () => {
        setIsTestimonialEdit(true)
    }

    const updateTestimonial = async (payload, iconClickedName) => {
        console.log(iconClickedName, ">>>>>iconClickedName on update testimonial");

        try {
            const updateTestimonial = await api.updatePersonaDetail(payload)

            if (updateTestimonial) {
                toast(String(`${iconClickedName} testimonal updated successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });

                console.log(payload.sMobile, ">>>>>payload.sMobile try");

                props.getUserPersonaDetails(payload.sMobile)
                setEditedTestimonialVal("");
                setIsTestimonialModalOpen(false);
                setIconClickedName(null);
                setIsTestimonialEdit(false)
            }
        } catch {
            console.log(payload.sMobile, ">>>>>payload.sMobile catch");
            toast(String(`${iconClickedName} testimonal not updated`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setEditedTestimonialVal("");
            setIsTestimonialModalOpen(false);
            setIconClickedName(null);
            setIsTestimonialEdit(false)
        }
    }

    const handleUpdateTestimonial = () => {
        console.log(iconClickedName, ">>>>iconClickedName");

        if (iconClickedName == "video") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": editedTestimonialVal } };
            updateTestimonial(payload, iconClickedName)
        }

        if (iconClickedName == "audio") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": editedTestimonialVal } };
            updateTestimonial(payload, iconClickedName)
        }

        if (iconClickedName == "text") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": editedTestimonialVal } };
            updateTestimonial(payload, iconClickedName)
        }
    }

    const deleteTestimonialFunction = async (payload, deleteTestimonialType) => {
        console.log(payload, ">>>>delete testi oayload");

        try {
            const deleteTestimonialResponse = await api.jpmcThreeSixtyDegreeViewDeletePersonaDetails(payload)

            if (deleteTestimonialResponse) {
                toast(String(`${deleteTestimonialType} testimonial deleted successully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                props.getUserPersonaDetails(payload.sMobile)
                setVideo("");
                setAudio("");
                setText("");
                setIconClickedName(null)
                setIsTestimonialModalOpen(false);
            }
        } catch (err) {
            toast(String(`${deleteTestimonialType} testimonial not deleted`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
            setIconClickedName(null)
            setIsTestimonialModalOpen(false);
        }
    }
    const handleDelete = async (deleteTestimonialType) => {
        console.log(deleteTestimonialType, ">>>deleteTestimonialType");

        if (deleteTestimonialType == "video") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": addedTestimonials?.Video } };
            deleteTestimonialFunction(payload, deleteTestimonialType)
        }

        if (deleteTestimonialType == "audio") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": addedTestimonials?.Audio } };
            deleteTestimonialFunction(payload, deleteTestimonialType)
        }

        if (deleteTestimonialType == "text") {
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": addedTestimonials?.Text } };
            deleteTestimonialFunction(payload, deleteTestimonialType)
        }
    }

    const addTestimonialFunction = async (payload, testimonialType) => {
        try {
            const res = await api.jpmcThreeSixtyDegreeViewSavePersonaDetails(payload);
            console.log(res, ">>>>res on upload audio");

            if (res) {
                toast(String(`${testimonialType} testimonal saved successfully`), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                props.getUserPersonaDetails(payload.sMobile)
                setVideo("");
                setAudio("");
                setText("");
                setIsTestimonialModalOpen(false);
            }
        } catch (err) {
            toast(String(`${testimonialType} not added`), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            setVideo("");
            setAudio("");
            setText("");
        }
    }

    const handleAddTestimonial = async (testimonialType) => {
        console.log(testimonialType, ">>>>testimonialType");
        if (testimonialType == "video" && video) {
            console.log(video, ">>>>video");
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Video": video } };
            addTestimonialFunction(payload, testimonialType)
        }

        if (testimonialType == "audio" && audio) {
            console.log(audio, ">>>>audio");
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Audio": audio } };
            addTestimonialFunction(payload, testimonialType)
        }

        if (testimonialType == "text" && text) {
            console.log(text, ">>>>text");
            const { nUserId, sMobile, nEntryId } = props?.userDetail[0];
            const payload = { "nUserId": nUserId, "sMobile": sMobile, "Type": "Testimonials", "subType": "Testimonials", "nResourceInstanceId": nEntryId, "fields": { "Text": text } };
            addTestimonialFunction(payload, testimonialType)
        }

    }

    console.log(selectedOption, ">>>>>selectedOption");
    console.log(video, ">>>>selected video");
    console.log(audio, ">>>>Selected audio");
    console.log(props.userDetail, ">>>>>props.userDetail");
    console.log(addedTestimonials, ">>>>addedTestimonials in userDetailContainer");

    const renderUserData = () => {
        console.log("user details props", props.userDetail);

        let temp = props.userDetail.map((e, index) => {
            return (
                <div key={index}>
                    <section className={`user-information user-informationTwo userinfowidth ${props.isPersonaLoading && "set-opacity"}`}>
                        {props.isPersonaLoading && <Spinner className="center" />}
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className="heading">User Information</h3>
                                </div>
                            </div>
                            <div className="row table-row" style={{ width: "100%" }}>
                                <div className="col-md-6 col1">
                                    <div className="inline">
                                        <h4>User Id:{" "}</h4>
                                        <p>
                                            {`${e["nUserId"] ?? ""}`}
                                        </p>
                                    </div>

                                    <div className="inline">
                                        <h4>Entry Id:{" "}</h4>
                                        <p>
                                            {`${e["nEntryId"] ?? ""}`}
                                        </p>
                                    </div>

                                    <div className="inline">
                                        <h4>Name:</h4>
                                        <p>{`${e["sFirstName"]} ${e["sLastName"]}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Contact No:</h4>
                                        <p>{`${e["sMobile"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Email:</h4>
                                        <p>{`${e["sEmailAddress"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Date of Joining:{" "}</h4>
                                        <p>
                                            {moment(e["dtCreated"]).format("DD/MM/YYYY")}
                                            {/* {`${e["age"]}`} */}
                                        </p>
                                    </div>
                                    <div className="inline">
                                        <h4>Gender:</h4>
                                        <p>{`${e["sGender"] ?? ""}`}</p>
                                    </div>

                                    <div className="inline">
                                        <h4>Age:</h4>
                                        <p>{`${e["age"] ?? ""}`}</p>
                                    </div>
                                </div>
                                <div className="col-md-6 col2">
                                    <div className="inline">
                                        <h4>Business Name:</h4>
                                        <p>{`${e["sBusinessName"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Turnover:{" "}</h4>
                                        <p>{`${e["sBusinessTurnover"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Pincode:{" "}</h4>
                                        <p>
                                            {`${e["sBusinessPincode"] ?? ""}`}
                                        </p>
                                    </div>
                                    <div className="inline">
                                        <h4>Location:</h4>
                                        {/* <p>{`${e["country"] ?? ""}`}</p> */}
                                        <p>{`${e["location"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Family Income:</h4>
                                        <p>{`${e["sFamilyIncome"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Started Year:</h4>
                                        <p>{`${e["sBusinessStartedYear"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Business Sector:</h4>
                                        <p>{`${e["sBusinessSector"] ?? ""}`}</p>
                                    </div>
                                    <div className="inline">
                                        <h4>Catologue URL:</h4>
                                        {/* <p>{`${e[""] ?? ""}`}</p> */}
                                        <p>
                                            {e["sCatalogueUrl"] ? (
                                                <>
                                                    <a
                                                        style={{
                                                            color: "rgb(118, 40, 124)",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                        }}
                                                        href={e["sCatalogueUrl"]}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        yes
                                                    </a>
                                                </>
                                            ) : (
                                                "no"
                                            )}
                                        </p>
                                        {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
                                    </div>
                                    <div className="inline">
                                        <h4>User Testimonial:</h4>

                                        <p>
                                            <>
                                                {/* <span><audioIcon width="40" height="40" fill="#76287c" /></span> */}
                                                {
                                                    addedTestimonials?.Video ? (
                                                        <img name="video" src={videoIcon} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img name="video" src={videoIcon2} alt="Video Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }

                                                {
                                                    addedTestimonials?.Audio ? (
                                                        <img name="audio" src={audioIcon} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img name="audio" src={audioIcon2} alt="Audio Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }

                                                {
                                                    addedTestimonials?.Text ? (
                                                        <img name="text" src={textIcon} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px" }} />
                                                    ) : (
                                                        <img name="text" src={textIcon2} alt="Text Icon" width="30" height="30" style={{ paddingRight: "10px", filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                    )
                                                }
                                                {/* <img onClick={handleTestimonialIconClick} src={videoIcon} alt="Video Icon" width="28" height="58" /> */}
                                                {/* <img onClick={handleTestimonialIconClick} src={audioIcon} alt="Audio Icon" width="32" height="32" /> */}
                                                {/* <img onClick={handleTestimonialIconClick} src={textIconTwo} alt="Text Icon" width="58" height="58" /> */}
                                                {/* <img src={viewIconTwo} alt="View Icon" width="30" height="30" /> */}
                                            </>
                                        </p>
                                        {/* <Typography><strong>Catalogue URL:</strong>{<a style={{ color: "rgb(118, 40, 124)", textDecoration: "underline", cursor: "pointer", marginLeft:"5px" }} href={`${user.sCatalogueUrl}`} target="_blank">yes</a> || "no"}</Typography> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                // ""

            );
        });
        return (
            <div>
                <div>
                    <span>
                        <b>{props.label}</b>
                    </span>
                </div>

                {temp}
            </div>
        );
    };


    return props.userDetail ? (
        <>

            {renderUserData()}

            {/* Modal open to add, edit or play testimonial when clicked any of icon */}
            <Modal isOpen={isTestimonialModalOpen}>
                <ModalContent className="dreambig-device-vehicle-filter-modal">
                    <div className="modal-header" style={{
                        // backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">Add Testimonials</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            // onClick={()=>handleCloseSmsModel(false)}
                            onClick={handleCancelUploadNew}
                        />
                    </div>

                    <div className="modal-body">
                        <div>
                            {/* {loadingInModal && <Spinner className="center" />} */}
                            <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
                                {
                                    <div className="" style={{
                                        height: "300px",
                                        backgroundColor: "",
                                    }}>
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            {
                                                <div style={{ marginBottom: '20px', width: '100%' }}>
                                                    {
                                                        addedTestimonials?.Video ? (
                                                            iconClickedName == "video" && <TextField
                                                                name="Video Testimonial"
                                                                label="Video Testimonial"
                                                                value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Video}
                                                                onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                                disabled={isTestimonialEdit ? false : true}
                                                            />
                                                        ) : (
                                                            iconClickedName == "video" && <TextField
                                                                name="Add Video Testimonial"
                                                                label="Add Video Testimonial"
                                                                value={video}
                                                                onChange={(e) => setVideo(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                        )
                                                    }

                                                    {
                                                        addedTestimonials?.Audio ? (
                                                            iconClickedName == "audio" && <TextField
                                                                name="Audio Testimonial"
                                                                label="Audio Testimonial"
                                                                value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Audio}
                                                                onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                                disabled={isTestimonialEdit ? false : true}
                                                            />
                                                        ) : (
                                                            iconClickedName == "audio" && <TextField
                                                                name="Add Audio Testimonial"
                                                                label="Add Audio Testimonial"
                                                                value={audio}
                                                                onChange={(e) => setAudio(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                        )
                                                    }

                                                    {
                                                        addedTestimonials?.Text ? (
                                                            iconClickedName == "text" && <TextField
                                                                name="Text Testimonial"
                                                                label="Text Testimonial"
                                                                value={isTestimonialEdit ? editedTestimonialVal : addedTestimonials?.Text}
                                                                onChange={(e) => setEditedTestimonialVal(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                                disabled={isTestimonialEdit ? false : true}
                                                            />
                                                        ) : (
                                                            iconClickedName == "text" && <TextField
                                                                name="Add Text Testimonial"
                                                                label="Add Text Testimonial"
                                                                value={text}
                                                                onChange={(e) => setText(e.target.value)}
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                        )
                                                    }
                                                </div>
                                            }
                                        </div>

                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-12 mt-3 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>

                                                {/* if testimonial exist- edit, open,cancel and if not only add and cancel */}
                                                {
                                                    iconClickedName == "video" && (
                                                        addedTestimonials.Video ?
                                                            <>
                                                                {
                                                                    isTestimonialEdit ?
                                                                        <Button onClick={handleUpdateTestimonial}>Update</Button>
                                                                        :
                                                                        <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                }

                                                                <Button>
                                                                    <a href={addedTestimonials?.Video} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                </Button>

                                                                <Button onClick={() => handleDelete("video")}>Delete</Button>
                                                            </>
                                                            :
                                                            <Button onClick={() => handleAddTestimonial("video")}>Add</Button>
                                                    )
                                                }

                                                {
                                                    iconClickedName == "audio" && (
                                                        addedTestimonials.Audio ?
                                                            <>
                                                                {
                                                                    isTestimonialEdit ?
                                                                        <Button onClick={handleUpdateTestimonial}>Update</Button>
                                                                        :
                                                                        <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                }

                                                                <Button>
                                                                    <a href={addedTestimonials?.Audio} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                </Button>

                                                                <Button onClick={() => handleDelete("audio")}>Delete</Button>
                                                            </>
                                                            :
                                                            <Button onClick={() => handleAddTestimonial("audio")}>Add</Button>
                                                    )
                                                }

                                                {
                                                    iconClickedName == "text" && (
                                                        addedTestimonials.Text || addedTestimonials.TextDetail ?
                                                            <>
                                                                {
                                                                    isTestimonialEdit ?
                                                                        <Button onClick={handleUpdateTestimonial}>Update</Button>
                                                                        :
                                                                        <Button onClick={editTestimonialClicked}>Edit</Button>
                                                                }

                                                                <Button>
                                                                    <a href={addedTestimonials?.Text} target="_blank" style={{ textDecoration: "none", color: "#fff" }}>Open</a>
                                                                </Button>

                                                                <Button onClick={() => handleDelete("text")}>Delete</Button>
                                                            </>
                                                            :
                                                            <Button onClick={() => handleAddTestimonial("text")}>Add</Button>
                                                    )
                                                }
                                                <Button onClick={handleCancelUploadNew}>Cancel</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </Modal>
        </>
    ) : (
        <div>
            <span>
                <b>{props.label}</b>
                <br></br>
                <a href="https://webapp.deasra.in/LeadUniversalSearch" target="_blank" style={{ marginLeft: "" }}>
                    <span className="lpm-cons-btns-bordered-filter" style={{ fontSize: "15px" }}>Go to universal search</span>
                </a>
                <br></br>
                <span style={{ marginLeft: "1.5%", fontWeight: "bold" }}>No data found</span>
            </span>
        </div>
    );
}

export default memo(UserDetailContainerTwo);